import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Log } from "@interfaces/log.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { ExportLogService } from "@services/exportLog.service";
import { LogService } from "@services/logs.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "logs",
	styleUrls: ["logs.css"],
	templateUrl: "logs.html"
})
export class LogAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	itemType = "Log";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: Log[] = [];
	title = "System Logs";

	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: LogService, private protectedGridService: ProtectedGridService) {
		this.viewRow = this.viewRow.bind(this);
		this.getItems();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("System Logs")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if(result)
		{
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	getItems() {
		this.itemService.getAll()
			.subscribe(
				(res: any) => this.items = res.response.items,
				(err) => console.log(err),
			);
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Logs";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`admin/logs/${e.row.data.id}`]);
	}
}